import React from 'react';
import './hb-money.scss';
import {
  getWallet,
  walletRecharge,
} from 'hb-redux-store/feature/wallet/wallet.action';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Icon from 'components/mweb/Icon/Icon';
import SecondaryNav from 'components/mweb/SecondaryNav/SecondaryNav';
import Input from 'components/mweb/Input/Input';
import Button from 'components/common/Button/Button';
import bgImage from 'assets/icons/icon-hb-money-bg.svg';
import webBgImage from 'assets/icons/icon-hb-money-bg-web.svg';
import earnCoin from 'assets/icons/earncoin.svg';
import Loader from 'components/mweb/Skeletons/Loader/Loader';
import Messages from 'components/mweb/Messages/Messages';

import {
  queryStringToJSON,
  vibrate,
} from 'hb-redux-store/util/miscellaneousServices';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { checkoutPrefix } from '../../checkout/checkout.routes';
import {
  DEVICE_TYPE,
  RUPEE_SYMBOL,
  SOURCE,
} from 'hb-redux-store/util/constantServices';
import { getDeviceType } from 'hb-redux-store/util/DeviceDetectionService';
import history from 'hb-redux-store/history';
import { getItem, setItem } from 'hb-redux-store/util/localStorageService';
import PaymentHeader from '../../checkout/PaymentHeader';
import { setPaymentSummaryModal } from 'hb-redux-store/feature/modal/modal.action';
import AnalyticsService from 'AnalyticsService';

const { clevertap } = AnalyticsService;

const HBMoney = props => {
  const {
    walletData,
    loading,
    getWallet,
    walletTransactionHistory = [],
    launchInfo,
  } = props;
  const { customerType } = launchInfo || {};
  const { amount } = props.match?.params || {};
  const title = 'VXL Money';
  const pageSize = 10;
  const [rechargeWalletAmount, setRechargeAmount] = React.useState();
  // const [rechargeNo, setRechargeNo] = useState('')
  const [editMode, setEditMode] = React.useState(amount === 'amount');
  const [minrc, setMinRc] = React.useState(0);
  const [cta, setCta] = React.useState('Recharge');
  const [loadMoreInProgress, setLoadMoreInProgress] = React.useState(false);
  const [pageNo, setPageNo] = React.useState(0);
  const [showHbPointsBanner, setHbPointsBanner] = React.useState(false);
  const qs = props.location.search;
  let { result, reason } = queryStringToJSON(qs);
  const isRechargeForOrder =
    props?.match?.path === `/${checkoutPrefix}/hb-money` ||
    props?.match?.path === `/${checkoutPrefix}/shipment` ||
    props?.match?.path === `/${checkoutPrefix}/payment`;
  const isMobileDevice = getDeviceType() === DEVICE_TYPE.MWEB;
  const setCtaText = amount =>
    setCta(`Add ${amount ? RUPEE_SYMBOL : ''}${amount} & Place Order`);
  React.useEffect(() => {
    const key = 'View VXL Money';
    const payload = {
      source: 'VXL Money',
      customerType,
    };
    clevertap.sendCleverTapEvent(key, payload);
  }, []);
  React.useEffect(() => {
    const rechargeNo = reason || '';
    if (pageNo > 0) setLoadMoreInProgress(true);
    getWallet({
      source: isRechargeForOrder ? SOURCE.RECHARGE_FOR_ORDER : '',
      pageNo,
      pageSize,
      rechargeNo,
      cb: ({ minimumAmount }) => {
        if (pageNo === 0) {
          if (isRechargeForOrder) setEditMode(true);
          if (minimumAmount) {
            setMinRc(minimumAmount);
            setRechargeAmount(minimumAmount);
          }
          const trackedOrder = getItem('trackedOrder') || {};
          if (isRechargeForOrder && minimumAmount) setCtaText(minimumAmount);
          if (result === 'success' && !trackedOrder[reason]) {
            props.setAppNotification('Your wallet recharge is successful');
            setHbPointsBanner(true);
            trackedOrder[reason] = new Date();
            setItem('trackedOrder', trackedOrder);
          }
        } else {
          setLoadMoreInProgress(false);
        }
      },
    });
  }, [pageNo]);
  React.useEffect(() => setEditMode(amount === 'amount'), [amount]);
  let { walletBalance = 0, amountOptions = [], rechargePoints = '' } =
    walletData || {};
  const showMobileRechargeBanner =
    rechargePoints && showHbPointsBanner && isMobileDevice && !editMode;
  const showDesktopRechargeBanner =
    rechargePoints && !isMobileDevice && !editMode;
  const uspImg =
    'https://ik.imagekit.io/iwcam3r8ka/prod/wallet/202104/0d58646a-4830-4941-813d-53f871e90c80.png';
  const processRecharge = () => {
    if (!rechargeWalletAmount) {
      return props.setAppNotification(
        'Please add sufficient amount to proceed'
      );
    }
    if (isNaN(rechargeWalletAmount) || rechargeWalletAmount <= 0) {
      return props.setAppNotification('Please add valid amount to proceed');
    }
    if (`${rechargeWalletAmount}`.split('.').length > 1) {
      return props.setAppNotification(
        'Please add valid amount without decimal to proceed'
      );
    }
    if (isRechargeForOrder && rechargeWalletAmount < parseFloat(minrc)) {
      return props.setAppNotification(
        `Minimum ${RUPEE_SYMBOL}${minrc} is required to place order.`
      );
    }
    const redirectUrl = isRechargeForOrder
      ? `/${checkoutPrefix}/vxl-money/recharge`
      : '/my/vxl-money/recharge';
    // console.log('AAAAAAAAA',parseFloat(rechargeWalletAmount));
    const key = 'Recharge Wallet';
    const payload = {
      source: 'VXL Money',
      customerType,
      amount: parseFloat(rechargeWalletAmount),
    };
    clevertap.sendCleverTapEvent(key, payload);
    props.walletRecharge({
      rechargeWalletAmount: parseFloat(rechargeWalletAmount),
      source: isRechargeForOrder ? SOURCE.RECHARGE_FOR_ORDER : '',
      redirectUrl,
      isRecharge: !isRechargeForOrder,
    });
  };
  const getHeader = () => {
    if (isMobileDevice) {
      if (isRechargeForOrder) {
        return (
          <PaymentHeader
            source="RECHARGE_FORM"
            summary={{ minrc }}
            onShowSummary={() => {
              if (!props.walletData?.summaryOrder?.length) return;
              props.setPaymentSummaryModal({
                visible: true,
                summary: { summaryOrder: props.walletData?.summaryOrder },
              });
            }}
          />
        );
      } else {
        return (
          <SecondaryNav
            title={title}
            capitalize
            source="accounts"
            showCart={false}
            showSearch={false}
            showFaq={true}
            onBackPress={
              !isRechargeForOrder && result === 'success' && reason
                ? () => history.push('/my/details')
                : null
            }
          />
        );
      }
    }
    return false;
  };

  const RechargeBanner = () => (
    <Messages
      message={rechargePoints}
      webClassName="hb-money--earnbox order-confirm--warn-color"
      icon={earnCoin}
      actionable={true}
      actionText={<span className="lefticon">🎉</span>}
      type="toast"
      messageStyle="order-confirm--message-style"
      onAction={() => {}}
    />
  );
  return (
    <div className={`hb-money ${isRechargeForOrder ? 'rc-for-order' : ''}`}>
      {getHeader()}
      {loading && pageNo <= 0 && <Loader />}
      <React.Fragment>
        {(showMobileRechargeBanner || showDesktopRechargeBanner) && (
          <RechargeBanner />
        )}
        <div className="position-relative">
          <img
            className="hb-money--card--bg"
            src={isMobileDevice ? bgImage : webBgImage}
          />
          <div className="hb-money--card">
            {editMode && (
              <React.Fragment>
                <div>
                  <div className="justify-content--space-between">
                    <div className="hb-money--card--title">Add {title}</div>
                    {/*<Icon class="icon-hb-money-wallet" height={28} width={36} />*/}
                  </div>
                  <div className="hb-money--card--amount">
                    {amountOptions.map(a =>
                      a.amountOptionsStatus ? (
                        <div
                          className={`amount ${
                            a.amountOptions == rechargeWalletAmount
                              ? 'selected'
                              : ''
                          }`}
                          key={a.amountOptionsId}
                          onClick={() => {
                            setRechargeAmount(a.amountOptions);
                            isRechargeForOrder && setCtaText(a.amountOptions);
                            vibrate();
                          }}
                        >
                          ₹{a.amountOptions}
                        </div>
                      ) : (
                        false
                      )
                    )}
                  </div>
                </div>
                <div>
                  <div className="justify-content--space-between">
                    <Input
                      className="hb-money--card--recharge-input"
                      type="mobile"
                      value={rechargeWalletAmount}
                      onChange={({ amount }) => {
                        setRechargeAmount(amount);
                        if (isRechargeForOrder) setCtaText(amount);
                      }}
                      allowOnlyDigits
                      maxLength={6}
                      name="amount"
                      placeholder="ENTER AMOUNT HERE"
                    />
                    <Link
                      to="/help/tnc"
                      className="button action-link more hb-money--card--tnc"
                    >
                      Terms & Conditions
                    </Link>
                  </div>
                </div>
              </React.Fragment>
            )}
            {!editMode && (
              <React.Fragment>
                <div>
                  <div className="justify-content--space-between">
                    <div className="hb-money--card--title">Add {title}</div>
                  </div>
                  <div className="hb-money--card--amount">
                    <div className="balance">₹{walletBalance}</div>
                  </div>
                </div>
                <div>
                  <div className="justify-content--space-between">
                    <Button
                      className="button hb-money--add-money-button large"
                      onClick={() => {
                        const key = 'Add More Money';
                        const payload = {
                          source: 'VXL Money',
                          customerType,
                        };
                        clevertap.sendCleverTapEvent(key, payload);
                        history.push('/my/vxl-money/amount');
                      }}
                    >
                      Add More Money
                    </Button>
                    <Link
                      to="/help/tnc"
                      className="button action-link more hb-money--card--tnc"
                    >
                      Terms & Conditions
                    </Link>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
        {!isMobileDevice && editMode && (
          <Button
            className="button button-primary full-width large"
            disabled={rechargeWalletAmount <= 0}
            onClick={processRecharge}
          >
            {cta}
          </Button>
        )}
        <div className="hb-money--usp std-margin-lr">
          <img src={uspImg} />
        </div>
        {!editMode && walletTransactionHistory.length === 0 && (
          <div className="hb-money--empty std-margin-lr">
            You haven’t made any transaction on Fast Money yet. Please add money
            to have faster transaction
          </div>
        )}
        {!editMode && walletTransactionHistory.length > 0 && (
          <div className="hb-money--transactions">
            <div className="hb-money--transactions--title">
              Transaction History
            </div>
            {walletTransactionHistory.map(tnx => {
              return (
                <div
                  className="hb-money--transaction std-margin-lr"
                  key={tnx.hbWalletLedgerId || Math.random()}
                >
                  <Icon src={tnx.imageUrl} size={30} />
                  <div className="hb-money--transaction--details">
                    <div className="justify-content--space-between">
                      <div className="hb-money--transaction--details--main-text">
                        <span className="bold">₹{tnx.amount}</span>
                        <span>&nbsp;{tnx.status}</span>
                      </div>
                      {tnx.date && (
                        <div className="hb-money--transaction--details--date">
                          {tnx.date}
                        </div>
                      )}
                    </div>
                    <div className="hb-money--transaction--details--sub-text">
                      {tnx.source}
                    </div>
                  </div>
                </div>
              );
            })}
            {walletData?.walletTransactions?.length === pageSize && (
              <div className="hb-money--transactions--view-more">
                <Button
                  className="button button-ghost full-width large"
                  onClick={() => setPageNo(pageNo + 1)}
                  disabled={loadMoreInProgress}
                >
                  View More Transactions
                </Button>
              </div>
            )}
          </div>
        )}
        {editMode && isMobileDevice && (
          <div className="bottom-sticky-cta">
            <Button
              className="button button-primary full-width large"
              onClick={processRecharge}
            >
              {cta}
            </Button>
          </div>
        )}
      </React.Fragment>
    </div>
  );
};

const mapStateToProps = ({ walletReducer, initialReducer }) => ({
  walletData: walletReducer.walletData,
  walletTransactionHistory: walletReducer.walletTransactionHistory,
  loading: walletReducer.loading,
  launchInfo: initialReducer.launchInfo || {},
});

const mapDispatchToProps = {
  getWallet,
  walletRecharge,
  setAppNotification,
  setPaymentSummaryModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(HBMoney);
